class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.stickyBar = null;
    this.buyButtonsBlock = null;
    this.observer = null;
    this.scrollThrottle = null;
  }

  connectedCallback() {
    this.stickyBar = document.querySelector('[data-sticky-atc]');
    if (!this.stickyBar) return;

    // Find the main add-to-cart area - could be buy-buttons-block or booking-journey-btn
    // Check which one is actually visible (not display: none via CSS)
    const buyButtonsBlock = document.querySelector('.product-details .buy-buttons-block');
    const bookingJourneyBtn = document.querySelector('.product-details booking-journey-btn');
    
    if (buyButtonsBlock && getComputedStyle(buyButtonsBlock).display !== 'none') {
      this.buyButtonsBlock = buyButtonsBlock;
    } else if (bookingJourneyBtn && getComputedStyle(bookingJourneyBtn).display !== 'none') {
      this.buyButtonsBlock = bookingJourneyBtn;
    } else {
      // Fallback
      this.buyButtonsBlock = buyButtonsBlock || bookingJourneyBtn;
    }
    
    if (!this.buyButtonsBlock) return;

    this.setupIntersectionObserver();
    this.setupVariantSync();
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.hideStickyBar();
        } else {
          this.showStickyBar();
        }
      });
    }, options);

    this.observer.observe(this.buyButtonsBlock);
  }

  setupVariantSync() {
    const stickyForm = this.stickyBar.querySelector('[data-type="add-to-cart-form"]');
    const stickySelect = this.stickyBar.querySelector('.sticky-add-to-cart__variant-select');
    const stickyBookingBtn = this.stickyBar.querySelector('booking-journey-btn button');
    const stickyVariantInput = stickyForm?.querySelector('[name="id"]');
    const stickyPriceEl = this.stickyBar.querySelector('.price');
    const stickyAtcBtn = this.stickyBar.querySelector('[ref="addToCartButton"]');

    // Listen for variant:update events on document (events bubble up)
    document.addEventListener('variant:update', (event) => {
      const variant = event.detail?.resource;
      if (!variant) return;

      const variantId = variant.id?.toString();
      
      // Update sticky select
      if (stickySelect) {
        stickySelect.value = variantId;
      }
      
      // Update sticky form hidden input
      if (stickyVariantInput) {
        stickyVariantInput.value = variantId;
      }
      
      // Update sticky booking button
      if (stickyBookingBtn) {
        stickyBookingBtn.dataset.variantId = variantId;
      }

      // Update sticky price
      if (stickyPriceEl && variant.price != null) {
        const price = variant.price / 100;
        const formattedPrice = price % 1 === 0 ? price.toString() : price.toFixed(2);
        stickyPriceEl.textContent = formattedPrice;
      }

      // Update sticky ATC button disabled state
      if (stickyAtcBtn) {
        if (variant.available) {
          stickyAtcBtn.removeAttribute('disabled');
        } else {
          stickyAtcBtn.setAttribute('disabled', '');
        }
      }
    });

    // Sync sticky select changes to main variant picker
    if (stickySelect) {
      stickySelect.addEventListener('change', (e) => {
        const selectedVariantId = e.target.value;
        
        // Find and click the corresponding option in the main variant picker
        const mainVariantPicker = document.querySelector('.product-details variant-picker');
        if (mainVariantPicker) {
          const optionInput = mainVariantPicker.querySelector(`input[data-variant-id="${selectedVariantId}"]`);
          if (optionInput && !optionInput.checked) {
            optionInput.click();
          }
        }
        
        // Update sticky form hidden input
        if (stickyVariantInput) {
          stickyVariantInput.value = selectedVariantId;
        }
        
        // Update sticky booking button
        if (stickyBookingBtn) {
          stickyBookingBtn.dataset.variantId = selectedVariantId;
        }
      });
    }
  }

  showStickyBar() {
    this.stickyBar.removeAttribute('hidden');
  }

  hideStickyBar() {
    this.stickyBar.setAttribute('hidden', '');
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
